import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";

const DashboardChangeSelectedColumnsAPI = async (data) => {
  const user = useAuth();
  const url = APIURL + "/document/viewdashboardfiltered";
  return await axios.post(url, { access_token: user.token, ...data });
};

export default DashboardChangeSelectedColumnsAPI;
